// @flow

import * as React from 'react';
import Switch from 'sail/Switch';
import {useAnalytics, useOverlay} from 'docs/data';
import type {Account, Article} from 'docs/data';
import {XRaySidebarSection} from './XRaySidebarSection';

type OverlaysProps = {|
  account: Account,
  article: Article,
|};

export const Overlays = ({account, article}: OverlaysProps) => {
  const [overlays, setOverlay] = useOverlay();
  const {trackAction} = useAnalytics();

  return (
    <XRaySidebarSection title="Overlays">
      <Switch
        size="small"
        value={overlays.partials}
        onChange={(value) => {
          if (value) {
            trackAction('docs_xray', {type: 'view_partials'});
          }
          setOverlay('partials', value);
        }}
        label="Partials"
      />
    </XRaySidebarSection>
  );
};
